export enum MailingTypes {
  Staff = "Staff",
  FacilityStaff = "FacilityStaff",
  Residents = "Residents",
  Family = "Family",
  Custom = "Custom",
  PendingFamilyMembers = "PendingFamilyMembers",

  FamilyWithFEPOA = "Family with FEPOA",
  ArchivedFamilyMembers = "Archived family members",
  FamilyCanInviteOtherFamily = "Family with ability to invite other family",
  FamilyMembersNotUsingTheApp = "Family members not using the app",
  FamilyMembersWithTheAppActivated = "Family members with the app activated",
  FamilyMembersPerWing = "Family members per wing",
  FamilyMembersPerLevelOfCare = "Family members per Level of Care",
}

export enum MailingListContactTypes {
  Staff = "Staff users",
  Resident = "Residents",
  Family = "Family members",
  CustomContact = "Custom Contact",
  ImportedContact = "Imported Contact",
}